module.exports = __webpack_public_path__ + "img/box6-16.a7bcdc29.png";